import styled from "styled-components";

export const Paragraph = styled.p`
  line-height: 1.6em;
  margin: 16px 0;
  @media screen and (min-width: 961px) {
    text-align: center;
  }
`;
export const CenterParagraph = styled(Paragraph)`
  text-align: center;
`;
export const Note = styled(Paragraph)<{ attention?: boolean }>`
  text-align: left;
  position: relative;
  font-size: 0.86em;
  margin: 0 0 0 1em;

  &:before {
    content: "※";
    position: absolute;
    left: -1em;
    color: ${({ attention }) => (attention ? "#EB0000" : "inherit")};
  }

  @media screen and (min-width: 961px) {
    font-size: 0.75em;
  }
`;
export const CenterNote = styled(CenterParagraph)<{ attention?: boolean }>`
  position: relative;
  font-size: 0.86em;
  margin: 0;

  &:before {
    content: "※";
    color: ${({ attention }) => (attention ? "#EB0000" : "inherit")};
  }

  @media screen and (min-width: 961px) {
    font-size: 0.75em;
  }
`;

export const Attention = styled.strong`
  color: #eb0000;
`;
export const UList = styled.ul``;
export const ListItem = styled.li`
  line-height: 1.6em;
  list-style: inside;

  &::marker {
    content: "・";
  }
`;
export const LinkText = styled.a`
  color: #0000ff;
  text-decoration: underline;
`;
export const Breakable = styled.span`
  display: inline-block;
`;
